// frontend/src/services/api/modules/auth.js
import { API_URL } from '../config';
import { fetchWrapper } from '../utils/fetchWrapper';
import { clearTokenCache } from '../../../services/api/utils/fetchWrapper';
import { initFirebase } from "../../../firebaseConfig";

import { signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";

// ===== 🆕 FUNCIÓN PARA LOGIN DE ADMIN =====
export const signInWithGoogle = async () => {
  const { auth } = await initFirebase();
  const provider = new GoogleAuthProvider();
  
  try {
    // 🔑 PASO 1: Limpiar tokens de usuario final ANTES del login
    localStorage.removeItem('nfcToken');
    localStorage.removeItem('userToken');
    localStorage.removeItem('tokenType');
    localStorage.removeItem('authToken'); // Por si existe
    
    // PASO 2: Hacer login con Google
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    
    // PASO 3: Obtener token de Firebase y guardarlo específicamente para admin
    const token = await user.getIdToken();
    localStorage.setItem('adminToken', token); // Opcional, pero útil para debug
    localStorage.setItem('userType', 'admin'); // Marcar tipo de usuario

    return user;
  } catch (error) {
    console.error("❌ Error en signInWithGoogle:", error);
    throw error;
  }
};

// ===== 🆕 FUNCIÓN MEJORADA PARA CERRAR SESIÓN =====
export const signOutUser = async () => {
  const { auth } = await initFirebase();
  try {
    await signOut(auth);
    
    // Limpiar TODOS los tokens
    clearTokenCache();
    localStorage.removeItem('nfcToken');
    localStorage.removeItem('userToken');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('tokenType');
    localStorage.removeItem('userType');
    localStorage.removeItem('authToken');
  } catch (error) {
    console.error("❌ Error al cerrar sesión:", error);
  }
};

// Magic Links y autenticación
export const solicitarAccesoUsuario = async (correo) => {
  try {
    const baseUrl = window.location.origin;
    
    const response = await fetchWrapper(`${API_URL}/api/auth/solicitarAcceso`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ correo, baseUrl })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      return { 
        error: data.error || "Error al solicitar acceso",
        status: response.status 
      };
    }
    
    return { 
      success: true, 
      message: data.message,
      status: 200 
    };
  } catch (error) {
    console.error("Error en solicitarAccesoUsuario:", error);
    return { 
      error: "Error de conexión", 
      status: 500 
    };
  }
};

export const solicitarDesbloqueo = async (objetoId) => {
  try {
    const resp = await fetchWrapper(`${API_URL}/api/objetos/solicitarDesbloqueo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ objetoId }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al solicitar desbloqueo" };
    }
    return data;
  } catch (error) {
    console.error("Error en solicitarDesbloqueo =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const verificarCorreo = async (email) => {
  try {
    const response = await fetchWrapper(
      `${API_URL}/api/verificarCorreo?email=${encodeURIComponent(email)}`
    );
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return { error: errorData.error || "Error al procesar la solicitud" };
    }
    return await response.json();
  } catch (error) {
    console.error("Error verificando correo:", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const verificarActivacion = async (codigoAcceso) => {
  try {
    const response = await fetchWrapper(
      `${API_URL}/api/verificarActivacion?code=${encodeURIComponent(codigoAcceso)}`
    );
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return { error: errorData.error || "Error de red al verificar activación" };
    }
    return await response.json();
  } catch (error) {
    console.error("Error en verificarActivacion:", error);
    return { error: "Error de conexión con el servidor" };
  }
};